// frontend/src/components/project/StagePaidStatus.jsx
import { Checkbox, ListItemIcon } from '@mui/material';

const StagePaidStatus = ({ item, onCkeck }) => {
  return (
    <ListItemIcon>
      <Checkbox
        edge='start'
        checked={item.visible}
        tabIndex={-1}
        disableRipple
        onClick={(e) => onCkeck(item.linkId, e.target.checked)}
      />
    </ListItemIcon>
  );
};

export default StagePaidStatus;
